import React from 'react';
import { Container } from '@mui/material';
import { Box } from '@mui/system';
import { PanierCardInfo, L2DRLogoIcon } from '@europrocurement/l2d-modules';

const Accueil = function () {
    return (
        <Container>
            <Box sx={{ margin: '30px 200px 0px 200px' }}>
                <L2DRLogoIcon />
            </Box>
            <PanierCardInfo />
        </Container>
    );
};
export default Accueil;
